import { render, staticRenderFns } from "./LoaderVideo.vue?vue&type=template&id=2cf4658e&scoped=true&"
import script from "./LoaderVideo.vue?vue&type=script&lang=js&"
export * from "./LoaderVideo.vue?vue&type=script&lang=js&"
import style0 from "./LoaderVideo.vue?vue&type=style&index=0&id=2cf4658e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4658e",
  null
  
)

export default component.exports